import { ExternalLink, Mail } from "lucide-react";
import { socials } from "../data/social";
import { site } from "../data/site";

export default function Contact() {
  return (
    <>
      <section className="page-hero compact">
        <p className="eyebrow">Contact</p>
        <h1>Have a game, role, or collaboration in mind?</h1>
        <p>For publishing discussions, technical development, roles, collaboration, or project enquiries, contact SZ Interactive directly.</p>
      </section>
      <section className="section">
        <div className="section-inner contact-grid">
          <article className="contact-panel">
            <p className="eyebrow">Email</p>
            <h2>Direct contact</h2>
            <a className="big-link" href={`mailto:${site.email}`}><Mail size={22} aria-hidden="true" /> {site.email}</a>
          </article>
          <article className="contact-panel">
            <p className="eyebrow">Location</p>
            <h2>{site.location}</h2>
            <p>{site.address.street}<br />{site.address.city}<br />{site.address.postalCode}</p>
          </article>
          <article className="contact-panel">
            <p className="eyebrow">Social</p>
            <h2>Public updates</h2>
            {socials.map((social) => (
              <a key={social.href} className="big-link" href={social.href} target="_blank" rel="noreferrer">
                {social.label} <ExternalLink size={18} aria-hidden="true" />
              </a>
            ))}
          </article>
        </div>
      </section>
    </>
  );
}
